module.exports = __webpack_public_path__ + "static/media/ua.c59eb96c.svg";